<form
	class="sidebar__form {{classViewOnlyForm}}"
	[formGroup]="form"
>
	<h2 class="pax-title-h2">{{ 'bookingDetails.label.contactsLabel' | ibeadmin:'sync' }}</h2>
	<p class="muted bottom-gap">
		{{ 'bookingDetails.text.tapContactsDuringBookingChange' | ibeadmin:'sync' }}
	</p>

	<div class="form--edit-mode" *ngIf="displayMode === 'edit'">
		<div class="form-field--row grid no-padding">
			<div class="form-field col-6 col-tp-6 col-p-12">
				<label class="label" for="contacts--email">
					{{'bookingDetails.label.emailAddress' | ibeadmin:'sync'}}
				</label>
				<input
					class="input-text"
					formControlName="email"
					id="contacts--email"
				/>
				<div *ngIf="form.get('email').invalid && displayValidationMessages" 
					[attr.aria-label]="formContactsErrors('email') | ibeadmin:'sync'" 
					class="form-errors near-input">
					{{ formContactsErrors('email') | ibeadmin:'sync'}}
				</div>
			</div>
		</div>

		<div class="form-field--row grid no-padding">
			<div class="form-field col-3 col-tp-3 col-p-12">
				<app-select-input-indra
					selectId="selectPhoneType"
					placeholder="{{'bookingDetails.label.selectType' | ibeadmin:'sync'}}"
					id="contacts_type"
					formControlName="phoneType"
					[options]="contactTypes"
					selectLabel="{{'bookingDetails.alt.selectPhoneType' | ibeadmin: 'sync'}}"
				></app-select-input-indra>
				<span aria-live="polite" 
					[attr.aria-label]="formContactsErrors('phoneType') | ibeadmin:'sync'" 
					class="input-error" role="alert"
					*ngIf="form.controls['phoneType'].invalid && displayValidationMessages">
					{{ formContactsErrors('phoneType') | ibeadmin:'sync'}}
					</span>
			</div>

			<div class="form-field col-3 col-tp-3 col-p-12">
				<app-select-input-indra
					selectId="selectPhoneCountry"
					placeholder="{{'bookingDetails.label.country' | ibeadmin:'sync'}}"
					formControlName="phoneCountryCode"
					id="contacts--country"
					[options]="phoneCountryCodes"
					[optionsTranslated]="true"
					selectLabel="{{ 'bookingDetails.alt.selectPhoneCountry' | ibeadmin: 'sync'}}"
				>
				</app-select-input-indra>
				<span aria-live="polite" 
					[attr.aria-label]="formContactsErrors('phoneCountryCode') | ibeadmin:'sync'" 
					class="input-error" role="alert"
					*ngIf="form.controls['phoneCountryCode'].invalid && displayValidationMessages">
					{{ formContactsErrors('phoneCountryCode') | ibeadmin:'sync' }}
				</span>
			</div>

			<div class="form-field col-5 col-tp-5 col-p-12">
				<label class="label" for="contacts--number">
					{{'bookingDetails.label.number' | ibeadmin:'sync'}}
				</label>
				<input
					type="number"
					class="input-text"
					formControlName="phone"
					id="contacts--number"
				/>
				<span aria-live="polite" 
					[attr.aria-label]="formContactsErrors('phone') | ibeadmin:'sync'" 
					class="input-error" role="alert"
					*ngIf="form.controls['phone'].invalid && displayValidationMessages">
					{{ formContactsErrors('phone') | ibeadmin:'sync'}}
				</span>
			</div>
		</div>
		<a class="link right-gap" href="javascript:;" (click)="clearForm()"
			*ngIf="!isBookingPaymentPage && (hasChanges | async) && displayMode === 'edit'">
			{{'bookingDetails.text.clearDetails' | ibeadmin:'sync'}}
		</a>
		<a class="link" href="javascript:;" (click)="cancelEditForm()"
			*ngIf="!isBookingPaymentPage && (hasChanges | async) && displayMode === 'edit'">
			{{'bookingDetails.text.cancelEditing' | ibeadmin:'sync'}}
		</a>
		
		<hr class="separator">
	</div>

	<div class="form--view-mode" *ngIf="displayMode === 'view' && hasData">
				<div class="form-field--row grid no-padding">
					<div class="form-field col-6 col-tp-6 col-p-12">
						<span class="label">{{'bookingDetails.label.email' | ibeadmin:'sync'}}</span>
						<span class="value">{{ form.value?.email }}</span>
			</div>
			<div class="form-field col-6 col-tp-6 col-p-12">
				<span class="label">{{'bookingDetails.label.number' | ibeadmin:'sync'}}</span>
				<span class="value">{{ (form.value?.phoneCountryCode || '') + ' ' + (form.value?.phone || '') }}</span>
			</div>
		</div>
	</div>

	<button class="button button-main-line top-gap" (click)="openEditForm()"
		*ngIf="!isBookingPaymentPage && displayMode === 'view'">
		{{'bookingDetails.label.editContacts' | ibeadmin:'sync'}}
	</button>
</form>
